import React, {Suspense} from 'react'
import {I18nProvider} from '../i18n/i18nProvider'
import {useMsal, useIsAuthenticated, useAccount} from '@azure/msal-react'

import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom'
import {history} from '../helpers'
import routes from './PrivateRoutes'
import {AuthLayout} from './AuthLayout'
import {MasterLayout} from './MasterLayout'

import {Login, NotFound} from '../pages/Auth'
import {Profile} from '../pages/Profile'
import {ProfileEdit} from '../pages/Profile/Edit'
import {Notification} from '../pages/Notification'
import {PurchaseProposalRequest} from '../pages/Purchase'
import {ToastContainer} from 'react-toastify'
import {LayoutProvider, LayoutSplashScreen} from '../core'
import 'react-toastify/dist/ReactToastify.css'

import './App.scss'
import 'webdatarocks/webdatarocks.css'

const MainContent = () => {
  const {accounts} = useMsal()
  const account = useAccount(accounts[0] || {})

  const isAuthenticated = useIsAuthenticated() && account
  const {PUBLIC_URL} = window.ENVVARS.REACT_APP_PUBLIC_URL

  return (
    <div className='App d-flex flex-column flex-root'>
      <Router history={history} basename={PUBLIC_URL}>
        <Routes>
          {!isAuthenticated ? (
            <>
              <Route element={<AuthLayout />}>
                <Route path='/login' element={<Login />} />
                <Route index element={<Login />} />
                <Route path='/PurchaseProposalRequest/:id' element={<PurchaseProposalRequest />} />
                <Route path='*' element={<Navigate to='/login' />} />
              </Route>
            </>
          ) : (
            <>
              <Route element={<MasterLayout />}>
                <Route index element={<Navigate to='/dashboard' />} />
                {routes.map((route) => {
                  if (route.child) {
                    return route.child.map((child) => {
                      if (child.pages) {
                        return child.pages.map((page) => (
                          <Route path={page.path} key={page.key} element={page.element} />
                        ))
                      }

                      if (child.child) {
                        return child.child.map((grandChild) => {
                          if (grandChild.pages) {
                            return grandChild.pages.map((page) => (
                              <Route path={page.path} key={page.key} element={page.element} />
                            ))
                          }
                          return (
                            <Route
                              path={grandChild.path}
                              key={grandChild.key}
                              element={grandChild.element}
                            />
                          )
                        })
                      }

                      return <Route path={child.path} key={child.key} element={child.element} />
                    })
                  }
                  return <Route path={route.path} key={route.key} element={route.element} />
                })}
                <Route path='/profile' element={<Profile />} />
                <Route path='/profile/edit' element={<ProfileEdit />} />
                <Route path='/notification' element={<Notification />} />
                <Route path='*' element={<NotFound />} />
              </Route>
            </>
          )}
        </Routes>
      </Router>
    </div>
  )
}

export default function App() {
  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <MainContent />
            <ToastContainer />
          </LayoutProvider>
        </I18nProvider>
      </Suspense>
    </>
  )
}
